import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import EstimatedCostForm from 'components/quote/estimated-cost';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import { RouteV2Id } from 'routes/routesConfigV2';
import EstimatedCostPageStore, {
  EstimatedCostPageStoreContext,
  useEstimatedCostPageStore,
} from 'store/pages/quote/estimated-cost/pageStore';

const PageContent: React.FC = observer(() => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();
  const { getInitialData, isInitialLoading } = useEstimatedCostPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      isInitialLoading={isInitialLoading}
      domainParams={{ groupId, periodId, cartId }}
      pageId={RouteV2Id.QUOTE_ESTIMATED_COST}
      pageFooter={null}
    >
      <EstimatedCostForm />
    </PageInFlowNoSidebarLayout>
  );
});

const EstimatedCostPage: React.FC = () => {
  const { periodId, groupId, cartId } = useQuoteDomainParams();
  const pageStore = useMemo(() => new EstimatedCostPageStore({ periodId, groupId, cartId }), []);

  return (
    <EstimatedCostPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </EstimatedCostPageStoreContext.Provider>
  );
};

export default EstimatedCostPage;
